import {
  Box,
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
  Typography,
} from "@mui/material";
import React, { useState } from "react";

function NCXFormRadioButton(props) {
  const fieldname = props?.field?.properties?.fieldname;

  const onRadioSelected = (value) => {
    props?.handleInputChange(fieldname, value, props?.field);
  };

  const sharedBorder = {
    border: "1px solid #bdbdbd",
    borderRadius: "4px",
    margin: "2px",
    padding: "3px 5px 0 5px",
    height: "3em",
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
  };

  return (
    <Box key={props?.field._id} sx={{ marginBottom: "16px" }}>
      <FormControl disabled={props?.field?.properties?.readOnly}>
        <FormLabel>{props?.field?.properties?.label}</FormLabel>
        <RadioGroup column>
          {props?.field?.properties?.options.map((radioItem) => (
            <div
              key={radioItem?.value}
              onClick={(_) => onRadioSelected(radioItem?.value)}
              style={sharedBorder}
            >
              <FormControlLabel
                label={radioItem?.label}
                value={radioItem?.value}
                control={
                  <Radio onChange={(_) => onRadioSelected(radioItem?.value)} />
                }
              />
            </div>
          ))}
        </RadioGroup>
        {!!props?.validationErrors[fieldname] && (
          <Typography variant="caption" color="error">
            {props?.validationErrors[fieldname]}
          </Typography>
        )}
      </FormControl>
    </Box>
  );
}

export default NCXFormRadioButton;
